import { render } from "./submenu-form.vue?vue&type=template&id=affb2450"
import script from "./submenu-form.vue?vue&type=script&lang=js"
export * from "./submenu-form.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__